import { CenterCourse } from '../../../lib/types/models/center-course/center-course'
import {
  CenterCourseInput,
  CenterCourseRequestInput
} from '../../../lib/types/models/center-course/center-course-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createCenterCourse = async (input: CenterCourseRequestInput) => {
  const { centerId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.centers.createCenterCourse.url, { id: centerId }))
    .post<CenterCourse, CenterCourseInput>(data)
}
